import { PureComponent, type ReactNode } from "react";

export type NavbarDLProps = {
  children?: ReactNode;
};

export class NavbarDL extends PureComponent<NavbarDLProps> {
  render(): ReactNode {
    return (
      <div className="w-full py-2 shadow fixed relative z-20 overflow-hidden">
        <div className="container w-full h-10 flex items-center justify-between">
          {this.props.children}
        </div>
      </div>
    );
  }
}
